import { render } from "./DateTimeConfig.vue?vue&type=template&id=db4fa12a&ts=true"
import script from "./DateTimeConfig.vue?vue&type=script&lang=ts"
export * from "./DateTimeConfig.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__